import { kebabCase } from 'lodash-es';

import type { RouteTabConfig } from '@zen/Components/RouteTabs';
import { bookingShipmentsRoutes } from '@zen/Routes';
import type { Undefinable } from '@zen/utils/typescript';

import { ShipmentListTab, type ShipmentListTabConfig, ShipmentScope } from './types';

export const DEFAULT_SHIPMENT_SCOPE: ShipmentScope = ShipmentScope.ALL;

const unavailableShipmentScopes: ShipmentScope[] = [ShipmentScope.HIGH_PRIORITY];

export const getShipmentListTabSlug = (tab: ShipmentListTab): string => kebabCase(tab);

export const getShipmentListTabUrl = (tab: ShipmentListTab): string =>
  bookingShipmentsRoutes.index.getUrl(getShipmentListTabSlug(tab));

export const findShipmentListTabConfig = (
  tabsConfiguration: ShipmentListTabConfig[],
  slug: Undefinable<string>
): Undefinable<ShipmentListTabConfig> =>
  tabsConfiguration.find(({ tab }: ShipmentListTabConfig): boolean => getShipmentListTabSlug(tab) === slug);

export const getShipmentListRouteTabsConfig = (tabsConfiguration: ShipmentListTabConfig[]): RouteTabConfig[] =>
  tabsConfiguration.map(
    ({ component, label, tab }: ShipmentListTabConfig): RouteTabConfig => ({
      component,
      label,
      path: getShipmentListTabSlug(tab),
      url: getShipmentListTabUrl(tab)
    })
  );

export const isShipmentScopeAvailable = (scope: ShipmentScope): boolean => !unavailableShipmentScopes.includes(scope);

export const getShipmentScopeSlug = (scope: ShipmentScope): string => kebabCase(scope);

export const getShipmentScopeFromSlug = (slug: Undefinable<string>): ShipmentScope => {
  const matchingScope: Undefinable<ShipmentScope> = Object.values(ShipmentScope).find(
    (scope: ShipmentScope): boolean => isShipmentScopeAvailable(scope) && getShipmentScopeSlug(scope) === slug
  );

  return matchingScope ?? DEFAULT_SHIPMENT_SCOPE;
};

export const getShipmentScopeUrl = (scope: ShipmentScope): string =>
  bookingShipmentsRoutes.index.getUrl(getShipmentListTabSlug(ShipmentListTab.ALL_SHIPMENTS), getShipmentScopeSlug(scope));
